import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Box, BoxProps, boxBase } from './Box'
import { Color } from '../constants/color'
import { theme } from '../constants/theme'

export type CardProps = BoxProps & {
  border?: 'bottom' | 'left' | 'top'
  borderColor?: string
  children?: ReactNode
  elevated?: boolean
  hoverable?: boolean
}

/**
 * @deprecated Use `Paper` instead.
 */
export const Card = styled(Box)<CardProps>(({
  border,
  borderColor,
  ...props
}) => {
  const borderStyle = `6px solid ${borderColor ?? Color.LIGHTER_BLUE}`

  return {
    backgroundColor: props.backgroundColor ?? Color.WHITE,
    border: theme.border.style.thin,
    borderBottom: border === 'bottom' ? borderStyle : undefined,
    borderLeft: border === 'left' ? borderStyle : undefined,
    borderRadius: theme.border.radius.normal,
    borderTop: border === 'top' ? borderStyle : undefined,
    boxShadow: props.elevated
      ? theme.boxShadow.elevated
      : theme.boxShadow.normal,
    boxSizing: 'border-box',
    cursor: props.cursor,
    display: 'flex',
    flexDirection: 'column',
    userSelect: props.userSelect,
    whiteSpace: props.whiteSpace,
    ...boxBase(props),
    ...(props.hoverable
      ? {
          cursor: 'pointer',
          ':hover': {
            backgroundColor: props.backgroundColor ?? Color.LIGHTEST_BLUE,
          },
        }
      : {}),
  }
})
